import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
   mode: 'history',
  routes: [
    {
      path: '/',
      name: '溯源',
      component: resolve => require(['@/components/traceability/traceIndexs'], resolve)
    },
    {
      path: '/GenRedOne',
      name: '溯源查询',
      component: resolve => require(['@/components/traceability/traceIndex'], resolve),
      meta: {
        shows: true
      }
    },
    {
      path: '/traceResult/:code/:pwd',
      name: '溯源查询结果',
      component: resolve => require(['@/components/traceability/traceResult'], resolve),
      meta: {
        shows: true
      }
    },
    {
      path: '/syProject',
      name: '可溯源工程',
      component: resolve => require(['@/components/traceability/syProject'], resolve)
    },
    {
      path: '/500',
      name: '错误页500',
      component: resolve => require(['@/components/error/500'], resolve)
    },
    {
      path: '/updatebower',
      name: '游览器更新',
      component: resolve => require(['@/components/error/updatebower'], resolve)
    },
    {
      path: '/404',
      name: '错误页404',
      component: resolve => require(['@/components/error/404'], resolve)
    },
    {
      path: '*',
      redirect: '/404',
      name: '错误页',
      component: resolve => require(['@/components/error/404'], resolve)
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js